import { ReactNode, useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { NavItem } from './types';
import { cn } from '@/lib';

interface DashboardLayoutProps {
  children: ReactNode;
  sidebarItems: NavItem[];
  logo?: ReactNode;
  logoHref?: string;
  showNavigation?: boolean;
}

export function DashboardLayout({
  children,
  sidebarItems,
  logo,
  logoHref,
  showNavigation = true,
}: DashboardLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  const mainClass = showNavigation ? "lg:ps-64 flex flex-col" : " flex flex-col"

  return (<>
    <div className="bg-background min-h-0 flex flex-col full-screen">
      {showNavigation && <Header onMenuToggle={handleMenuToggle} />}

      {/* No spacing here: each page sets its own via PageContainer, so iFrame pages can fill edge to edge */}
      <main className={cn(mainClass, "grow overflow-y-hidden")}>
        {children}
        {/* <div className="p-4 sm:p-6 flex-1 flex flex-col">{children}</div> */}
      </main>
    </div>
    {showNavigation && (
      <Sidebar
        items={sidebarItems}
        logo={logo}
        logoHref={logoHref}
        isOpen={isSidebarOpen}
        onClose={handleSidebarClose}
      />
    )}
</>
  );
}
/* 
function Example() {
  return <div>
    <header
      className={`lg:ms-64 fixed top-0 inset-x-0 flex flex-wrap md:justify-start md:flex-nowrap z-50 bg-surface border-b border-border`}

    ></header>
    <main className={cn("g:ps-64 pt-14 min-h-screen flex flex-col")}>
      <div className="p-4 sm:p-6 flex-1 flex flex-col">
        {children}
      </div>
    </main>
  </div>

} */